import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import axiosService from '../../services/axios.service';

let metaRequest: any = null;
let listRequest: any = null;

const EventService = {
  getMeta: () => {
    metaRequest && metaRequest.cancel();
    metaRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`events/meta`), {
      cancelToken: metaRequest.token,
    });
  },
  getList(range?: string) {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    const filter: any = {};
    if (range) {
      filter.range = range;
    }
    return axiosService.get(getEndpointBase(`event/range`), {
      cancelToken: listRequest.token,
      params: {
        filter
      }
    });
  },
  remove(id: string) {
    return axiosService.delete(getEndpointBase(`event/${id}`));
  }
};

export default EventService;
